import React from 'react';
import './index.scss';
import Container from '../components/container';
import AllEvents from '../components/AllEvents';
import FeaturedEvent from '../components/featuredEvent';
import Layout from '../components/Layout';
import { useLocation } from '@reach/router';
import worldImg from '../assets/world.jpg';

interface Props {}

const Events: React.FC<Props> = () => {
  const { pathname } = useLocation();

  return (
    <div>
      <Layout coverImage={worldImg} pageTitle="Curated talks and online events in the developer ecosystem" description="The Fourth Act events page helps you stay updated on virtual conferences, talks, and other online events in the developer ecosystem." pathname={pathname}>
        <Container className="featuredEventContainerPadding">
          <FeaturedEvent />
        </Container>
        <Container className="featuredEventContainerPadding lightBlueBG">
          <AllEvents title="All Events" />
        </Container>
      </Layout>
    </div>
  );
};

export default Events;
